import { reactive, ref } from "vue-demi";
const usePagination = (params) => {
  const { pageSize, searchFun } = params;
  const paginationData = reactive({ currentPage: 1, pageSize });
  const total = ref(0);
  const currentChange = async (e) => {
    paginationData.currentPage = e;
    await searchFun(paginationData);
  };
  const pageSizeChange = async (e) => {
    paginationData.currentPage = 1;
    paginationData.pageSize = e;
    await searchFun(paginationData);
  };
  const searchFirstPage = async () => {
    paginationData.currentPage = 1;
    await searchFun(paginationData);
  };
  return {
    searchFirstPage,
    pageSizeChange,
    currentChange,
    paginationData,
    total
  };
};
export { usePagination };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/usePagination.js